module.exports = __webpack_public_path__ + "media/images/method-transferwise-38a9580cdf96e76ac731d7b02295777e.png";